export const buildProvenance = { "commitHash": "dfbd42d4c0aa2d4870ff5a5064ecacab0008bd17", "branchName": "refs/heads/release/2023.4", "buildDate": "2024-01-16T23:57:43.522Z", "version": "2023.4.8245" };
